"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.computeCountryLanguageFromPathname = void 0;
var _navigation = require("next/navigation");
var _server = require("../server");
var computeCountryLanguageFromPathname = pathname => {
  if (pathname) {
    var locale = (0, _server.getLocaleByPathname)(pathname);
    return (0, _server.getCountryLanguageByLocale)(locale || '');
  } else {
    return {
      country: 'gb',
      language: 'en'
    };
  }
};
exports.computeCountryLanguageFromPathname = computeCountryLanguageFromPathname;
var useCustomLocaleAppRouter = () => {
  var pathname = (0, _navigation.usePathname)();
  return computeCountryLanguageFromPathname(pathname);
};
var _default = exports.default = useCustomLocaleAppRouter;